module.exports = __webpack_public_path__ + "img/logo.ca04ec84.png";